class log {

   constructor(config) {
      this.config = config
   }

   error(msg, error) {
      this.getStackTrace(this._error, msg, error)
   }

   trace() {
      this.getStackTrace(this._trace)
   }

   _error(msg, error) {
      let callback = function (stack) {
         msg = Object.assign(window.log.config, msg);
         delete(msg.ajaxURL);
         StackTrace.report(stack, window.log.config.ajaxURL, msg);
         console.log('----- ERROR', {msg: msg, stack: stack});
      };
      if (typeof error != 'undefined' && error!=null) StackTrace.fromError(error).then(callback); // .catch(errback)
      else StackTrace.get().then(callback); // .catch(errback)
   }

   _trace() {
      if (process.env.WM == 'real') return;
      var callback = function (stackframes) {
         var stringifiedStack = stackframes.map(function (sf) {
            return sf.toString();
         }).join('\n');
         console.log(stringifiedStack);
      };

      var errback = function (err) {
         console.log(err.message);
      };
      StackTrace.get().then(callback).catch(errback);
   }

   loadScript(url, callback, ...args) {

      var script = document.createElement("script")
      script.type = "text/javascript";

      if (script.readyState) {  //IE
         script.onreadystatechange = function () {
            if (script.readyState == "loaded" ||
               script.readyState == "complete") {
               script.onreadystatechange = null;
               callback(...args);
            }
         };
      } else {  //Others
         script.onload = function () {
            callback(...args);
         };
      }

      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
   }

   getStackTrace(cb, ...args) {
      if (typeof StackTrace != 'object') {
         this.loadScript('//cdnjs.cloudflare.com/ajax/libs/stacktrace.js/2.0.0/stacktrace.min.js', cb, ...args);
      } else cb(...args);
   }
}

export default log